import { DocumentSchema, Message } from "../types/augmentations";
import {
  PersistentMessage,
  threadsDeleteThread,
  threadsGetThreadMessages,
  threadsUpdateThread,
} from "../sdk";
import { convertPersistentMessagesToWayakAIMessages } from "../messages/messages";

export async function getThreadMessages(threadId: string) {
  try {
    const response = await threadsGetThreadMessages({
      path: { thread_id: threadId },
    });
    const messages = response.data;
    if (!messages) {
      return null;
    }
    const convertedMessages =
      convertPersistentMessagesToWayakAIMessages(messages);
    return convertedMessages;
  } catch (error) {
    console.error("Failed to fetch messages:", error);
    return null;
  }
}

export async function editThreadV2(
  threadId: string,
  title: string,
  description: string
) {
  try {
    const response = await threadsUpdateThread({
      path: { thread_id: threadId },
      body: {
        title,
        description,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to update thread:", error);
    throw error;
  }
}

export async function deleteThread(threadId: string) {
  try {
    const response = await threadsDeleteThread({
      path: { thread_id: threadId },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to delete thread:", error);
    throw error;
  }
}
